export type DashboardSessionKey = "asia" | "us";

/**
 * Return the currently active trading session for dashboard scoping.
 *
 * The UI uses this only to choose which live/accountability slice to show by
 * default. It must stay display-only: trading session scheduling remains owned
 * by the Python session scheduler / session_times.py.
 */
export function activeSessionKey(now = new Date()): DashboardSessionKey | null {
  const utcH = now.getUTCHours();
  if (utcH >= 0 && utcH < 8) return "asia";
  if (utcH >= 13 && utcH < 21) return "us";
  return null;
}

export function defaultDashboardSession(now = new Date()): DashboardSessionKey {
  return activeSessionKey(now) ?? "us";
}
